import withFeatureBranch from '@wix/da-react-context/pkg/flags/withFeatureBranch';
import Logo from './Logo';
import HalloweenLogo from './Logo.halloween_2022';
export default withFeatureBranch({
    halloween_2022: HalloweenLogo
})(Logo);
